import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-charge-reason-modal',
  templateUrl: './charge-reason-modal.component.html'
})
export class ChargeReasonModalComponent {

  constructor(
    public activeModal: NgbActiveModal
  ) { }

}
